import React, { useState } from 'react'
import { format } from "date-fns";
import Loader from '@/shared/components/Loader';
import { useTranslation } from 'react-i18next';
import DateRange from '@/shared/components/DateRange';
import { toast } from 'react-toastify';
import { useGetTokenUsageMutation } from '@/api/rtk/mutationsApi'

const TokenUsage = () => {
  const { t } = useTranslation();
  const [getTokenUsage] = useGetTokenUsageMutation();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async ({ dateFrom, dateTo, setDateFrom, setDateTo }) => {
    setLoading(true);
    try {
      const result = await getTokenUsage({ dateFrom, dateTo }).unwrap();
      const usage = result?.usage;
      
      const csvHeader = `Name,Tokens\n`;
      const csvRows = usage.map(user => `${user.name},${user.tokens}`).join('\n');
      const csvContent = csvHeader + csvRows;
      
      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      const fileName = `token-usage-${format(dateFrom, "dd/MM/yy")}-to-${format(dateTo, "dd/MM/yy")}.csv`;
      
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting token usage:", error);
      toast.error('Failed to fetch token usage. Please try again.');
    } finally {
      setLoading(false);
      setDateFrom(null);
      setDateTo(null);
    }
  }

  return (
    <>
      <p className="text-black w-fit md:w-full font-SuisseIntlLight font-semibold text-base my-3 mt-5">
        {t("tokens.export")}
      </p>
      <DateRange 
        buttonText={loading ? <Loader /> : t("actions.export")}
        onSubmit={handleSubmit}
        loading={loading}
      />
    </>
  )
}

export default TokenUsage
